export const PAGE_LAYOUT_SCROLL_CONTAINER_ID = 'page-layout-scroll-container';
export const PAGE_CONTENT_ROW_ID = 'page-content-row';